import React, { useMemo } from 'react';
import { View, TouchableOpacity, Dimensions } from 'react-native';
import { Icons, Typography, useTheme } from '@hmsexp/component-library';

const Pagination = ({ currentPage, totalRecords, pageSize = 25, onPageChange }) => {
  const { palette } = useTheme();
  const screenWidth = Dimensions.get('window').width;

  const from = (currentPage - 1) * pageSize + 1;
  const to = Math.min(currentPage * pageSize, totalRecords);
  const totalPages = Math.ceil(totalRecords / pageSize);

  const maxButtons = useMemo(() => {
    if (screenWidth >= 450) return 9;
    if (screenWidth >= 380) return 7;
    return 5;
  }, [screenWidth]);

  const getPageNumbers = () => {
    if (totalPages <= maxButtons) {
      return [...Array(totalPages).keys()].map(n => n + 1);
    }

    const side = Math.floor((maxButtons - 3) / 2);
    const pages = [];

    if (currentPage <= side + 2) {
      pages.push(...[...Array(side + 3).keys()].map(n => n + 1), '...', totalPages);
    } else if (currentPage >= totalPages - (side + 1)) {
      pages.push(
        1,
        '...',
        ...Array(side + 3)
          .fill(0)
          .map((_, i) => totalPages - (side + 2) + i)
      );
    } else {
      pages.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
    }

    return pages;
  };

  const renderPageButton = (page, idx) => {
    const isCurrent = page === currentPage;
    const isEllipsis = page === '...';

    return (
      <TouchableOpacity
        key={`${page}-${idx}`}
        disabled={isEllipsis || isCurrent}
        onPress={() => !isEllipsis && onPageChange(page)}
        style={{
          marginHorizontal: 4,
          width: isEllipsis ? 20 : 34,
          height: isEllipsis ? 20 : 34,
          borderRadius: 17,
          backgroundColor: isCurrent ? '#eaf3ff' : '',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
        <Typography
          variant='body2'
          fontWeightType={isCurrent ? 'semiBold' : 'regular'}
          style={{
            color: isCurrent ? palette.white : palette.typographyPrimary
          }}>
          {page}
        </Typography>
      </TouchableOpacity>
    );
  };

  return (
    <View style={{ alignItems: 'center' }}>
      {totalPages > 1 && (
        <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center', marginTop: '2%' }}>
          <TouchableOpacity
            disabled={currentPage === 1}
            onPress={() => onPageChange(currentPage - 1)}
            style={{
              paddingHorizontal: 8,
              opacity: currentPage === 1 ? 0.3 : 1
            }}>
            <Icons.ChevronLeft size={18} />
          </TouchableOpacity>

          {getPageNumbers().map((p, i) => renderPageButton(p, i))}

          {/* RIGHT ARROW */}
          <TouchableOpacity
            disabled={currentPage === totalPages}
            onPress={() => onPageChange(currentPage + 1)}
            style={{
              paddingHorizontal: 8,
              opacity: currentPage === totalPages ? 0.3 : 1
            }}>
            <Icons.ChevronRight size={18} />
          </TouchableOpacity>
        </View>
      )}
      <View style={{ marginTop: '1%' }}>
        <Typography variant='body2' fontWeightType='regular'>
          {`Records ${from}–${to} of ${totalRecords}`}
        </Typography>
      </View>
    </View>
  );
};

export default Pagination;
